import {
  cssVar,
  HappySquareIcon,
  makeStyles,
  SadCloudIcon,
  SadSquareIcon,
  Typography,
} from '@amagimedia/amagi-design-system';
import { FC, ReactElement } from 'react';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    height: '90%',
    background: cssVar('--secondary-background-color'),
  },
  sadCloudIcon: {
    marginBottom: 20,
  },
  message: {
    marginBottom: 20,
    fontSize: 16,
    color: cssVar('--primary-text-color'),
    fontWeight: 'unset',
  },
});

export type iconType = 'sadCloud' | 'sadSquare' | 'happySquare';

const ICONS_MAP: Record<iconType, ReactElement> = {
  sadCloud: <SadCloudIcon />,
  sadSquare: <SadSquareIcon />,
  happySquare: <HappySquareIcon />,
} as const;

export const EmptyData: FC<IEmptyDataProps> = (props) => {
  const { message, ...rest } = props;
  const classes = useStyles();
  return (
    <div className={classes.root} {...rest}>
      <div className={classes.sadCloudIcon} data-testid={`${props.type}`}>
        {ICONS_MAP[props.type]}
      </div>
      <Typography className={classes.message}>{message}</Typography>
      {props.children}
    </div>
  );
};

interface IEmptyDataProps {
  message: string;
  type: iconType;
  style?: React.CSSProperties;
}
